const findInPage = {
  searchHoverLevel: 10000,
};

export default findInPage;
